(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_6589c5e"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-tabs-block')) {
    class CollectionTabsBlock extends HTMLElement {
      connectedCallback() {
        this.buttons = this.querySelectorAll('.collection-tabs__button');
        this.panels = this.querySelectorAll('.collection-tabs__panel');

        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => this.handleClick(event));
        });
      }

      activatePanel(panel) {
        const template = panel.querySelector(':scope > template[data-collection-template]');
        if (template) {
          // Editor de temas: el contenido viene en <template>
          const fragment = template.content.cloneNode(true);
          panel.appendChild(fragment);
          template.remove();
        } else if (!panel.dataset.loaded && !panel.childElementCount && panel.dataset.collectionUrl) {
          // Tienda: panel vacío → cargar bajo demanda vía Section Rendering API
          this.loadPanel(panel);
        }
        panel.classList.remove('is-hidden');
        panel.removeAttribute('hidden');

        // Doble rAF para que el layout se aplique antes de notificar al carrusel
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
            panel.dispatchEvent(new CustomEvent('panel:activated', { bubbles: true }));
          });
        });
      }

      loadPanel(panel) {
        if (panel.dataset.loading === 'true') return;
        panel.dataset.loading = 'true';

        const base = panel.dataset.collectionUrl;
        const sectionId = this.getAttribute('data-section-id');
        const url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

        panel.innerHTML = '<div class="collection-tabs__loading" aria-busy="true" aria-label="Cargando"></div>';

        fetch(url)
          .then((res) => {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            // En el HTML devuelto, la pestaña de esa colección sale activa
            // con sus tarjetas montadas: extraemos el panel homólogo por id.
            const remote = doc.getElementById(panel.id);
            if (!remote || !remote.childElementCount) throw new Error('panel vacío en la respuesta');
            panel.innerHTML = '';
            while (remote.firstChild) panel.appendChild(remote.firstChild);
            panel.dataset.loaded = 'true';
            window.dispatchEvent(new Event('resize'));
          })
          .catch((err) => {
            console.error('[collection-tabs] carga diferida falló:', err);
            panel.innerHTML =
              '<a class="collection-tabs__fallback-link" href="' + base + '">Ver colección</a>';
          })
          .finally(() => {
            delete panel.dataset.loading;
          });
      }

      deactivatePanel(panel) {
        panel.classList.add('is-hidden');
        panel.setAttribute('hidden', '');
      }

      handleClick(event) {
        const button = event.currentTarget;
        const index = button.dataset.tabIndex;

        this.buttons.forEach((b) => {
          const isActive = b.dataset.tabIndex === index;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          if (panel.dataset.panelIndex === index) {
            this.activatePanel(panel);
          } else {
            this.deactivatePanel(panel);
          }
        });
      }
    }

    customElements.define('collection-tabs-block', CollectionTabsBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["selector-sabor-variante"] && !Shopify.designMode) return;
  try {
    (function () {
    function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase(); }
    function fileTokens(src) { var f = (src || '').split('/').pop().split('?')[0]; return norm(f).split(/[^A-Z0-9]+/).filter(Boolean); }
    var SYN = { CHERRY: ['CEREZA'], CEREZA: ['CHERRY'], LIMON: ['LIMA'], LIMA: ['LIMON'], PLATANO: ['BANANA'], BANANA: ['PLATANO'] };
    function slideMatchesFlavor(src, tok) {
      var t = fileTokens(src);
      if (t.indexOf(tok) >= 0) return true;
      var alts = SYN[tok] || [];
      for (var i = 0; i < alts.length; i++) { if (t.indexOf(alts[i]) >= 0) return true; }
      return false;
    }
    function closestCard(el) {
      return el.closest('product-card, .card-wrapper, .card, .product-card, [data-product-card], .grid__item, li.grid__item') || el.parentElement;
    }
    function origSlides(card) {
      if (card.__fsvOrig) return card.__fsvOrig;
      var slides = card.querySelectorAll('slideshow-slide');
      card.__fsvOrig = Array.prototype.map.call(slides, function (s) {
        var i = s.querySelector('img');
        return i ? { id: s.getAttribute('slide-id'), src: i.getAttribute('src'), srcset: i.getAttribute('srcset') || '' } : null;
      });
      return card.__fsvOrig;
    }
    function updateImage(card, mediaId, flavor, index, fallbackImg) {
      var orig = origSlides(card);
      var chosen = null;
      if (mediaId) { for (var i = 0; i < orig.length; i++) { if (orig[i] && orig[i].id === mediaId) { chosen = orig[i]; break; } } }
      if (!chosen && flavor) { var tok = norm(flavor); for (var j = 0; j < orig.length; j++) { if (orig[j] && slideMatchesFlavor(orig[j].src, tok)) { chosen = orig[j]; break; } } }
      if (!chosen && index != null && orig[index]) chosen = orig[index];
      var newSrc = chosen ? chosen.src : fallbackImg;
      var newSrcset = chosen ? chosen.srcset : '';
      var slides = card.querySelectorAll('slideshow-slide');
      var firstImg = (slides[0] && slides[0].querySelector('img')) || card.querySelector('.product-media__image, .card__media img, .media img, img');
      if (firstImg && newSrc) { if (newSrcset) { firstImg.srcset = newSrcset; } else { firstImg.removeAttribute('srcset'); } firstImg.src = newSrc; }
      var ss = card.querySelector('slideshow-component');
      if (ss && typeof ss.select === 'function') { try { ss.select(0, undefined, { animate: false }); } catch (e) {} }
    }
    function updateLinks(card, url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        try { var u = new URL(a.getAttribute('href'), location.origin); var v = new URL(url, location.origin); u.search = v.search; a.setAttribute('href', u.pathname + u.search); }
        catch (e) { a.setAttribute('href', url); }
      });
    }
    function updatePrice(card, base, id) {
      try {
        var u = new URL(base.split('?')[0], location.origin);
        u.searchParams.set('variant', id);
        u.searchParams.set('section_id', 'section-rendering-product-card');
        fetch(u.href).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var np = doc.querySelector("product-price [ref='priceContainer']");
          if (!np) return;
          card.querySelectorAll("product-price [ref='priceContainer']").forEach(function (pc) { pc.innerHTML = np.innerHTML; });
        }).catch(function () {});
      } catch (e) {}
    }
    function reorder(root, btn) {
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fsv-dot]'));
      var first = dots.map(function (d) { return d.getBoundingClientRect(); });
      dots.forEach(function (d) { d.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var last = dots.map(function (d) { return d.getBoundingClientRect(); });
      dots.forEach(function (d, i) {
        var dx = first[i].left - last[i].left;
        if (Math.abs(dx) > 0.5 && d.animate) {
          d.animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'translateX(0)' }], { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
      });
    }
    function init(root) {
      if (!root || root.dataset.fsvInit) return;
      root.dataset.fsvInit = '1';
      var card = closestCard(root);
      var base = root.getAttribute('data-product-url') || '';
      root.querySelectorAll('[data-fsv-dot]').forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (dot.classList.contains('is-selected')) return;
          reorder(root, dot);
          var id = dot.getAttribute('data-variant-id');
          var media = dot.getAttribute('data-media-id');
          var flavor = dot.getAttribute('data-flavor');
          var idxAttr = dot.getAttribute('data-index');
          var index = idxAttr == null ? null : parseInt(idxAttr, 10);
          var img = dot.getAttribute('data-variant-image');
          var url = dot.getAttribute('data-variant-url');
          if (!card) return;
          updateImage(card, media, flavor, index, img);
          if (url) updateLinks(card, url);
          if (id && base) updatePrice(card, base, id);
        });
      });
    }
    function boot() { document.querySelectorAll('[data-fsv]:not([data-fsv-init])').forEach(init); }
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
